var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Authentication",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Authentication---Tablet-Copy-6",
    transform: "translate(-361.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Authentication/Tablet/Register",
    transform: "translate(85.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(182.000000, 184.000000)",
    fill: "#0063C7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Tick-circle",
    transform: "translate(94.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,0 C55.6695256,0 66.8610977,4.63570098 75.1126984,12.8873016 C83.364299,21.1389023 88,32.3304744 88,44 C88,68.300529 68.300529,88 44,88 C19.699471,88 0,68.300529 0,44 C0,19.699471 19.699471,0 44,0 Z M44,5.86666667 C22.9395415,5.86666667 5.86666667,22.9395415 5.86666667,44 C5.86666667,65.0604585 22.9395415,82.1333333 44,82.1333333 C65.0470625,82.1010277 82.1010277,65.0470625 82.1333333,44 C82.1333333,22.9395415 65.0604585,5.86666667 44,5.86666667 Z M62.9090909,26 L67,30.1264894 L37.7792208,59.1862735 C37.23026,59.7125031 36.4962171,60.0045026 35.7337662,60 C34.9713154,60.0045026 34.2372724,59.7125031 33.6883117,59.1862735 L22,47.5623599 L26.0909091,43.4358705 L35.7337662,53.0255993 L62.9090909,26 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.7c9022ba0daf51c9e722d959dc9665b3.svg";
export { ForwardRef as ReactComponent };